import React from 'react';

import { Loader } from '../../loader';

import { StyledLinkButton } from './link-button.styles';

import type { ButtonProps } from '../button';
import type { SxProps } from '@mui/material';

export type LinkButtonProps = ButtonProps & {
  automationId?: string;
  className?: string;
  id?: string;
  label: React.ReactNode | string;
  loading?: boolean;
  sx?: SxProps;
  variant?: 'danger' | 'primary' | 'secondary' | 'white';
};

// THIS IS A BUTTON STYLED TO LOOK LIKE A LINK
export function LinkButton({
  label,
  variant = 'primary',
  onClick,
  sx,
  disabled = false,
  loading = false,
  id = '',
  automationId = '',
  className,
}: LinkButtonProps): JSX.Element {
  return (
    <StyledLinkButton
      $variant={variant}
      className={className}
      data-testid={automationId}
      disabled={disabled}
      id={id}
      sx={sx}
      onClick={onClick}
    >
      {!loading && label}
      {loading && <Loader variant={variant === 'primary' ? 'blue' : 'black'} />}
    </StyledLinkButton>
  );
}
